import { render } from "./TransportDetail.vue?vue&type=template&id=a1f0b8cc&lang=pug"
import script from "./TransportDetail.vue?vue&type=script&lang=js"
export * from "./TransportDetail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__